export default __webpack_public_path__ + "static/media/search_btn.79ad0002.svg";